import { Enumify } from "enumify";

class Page extends Enumify {
  static page = new Page({
    defaultPage : 1
  });
  static size = new Page({
    defaultSize : 10,
  });
  static _ = this.closeEnum();

  constructor(props) {
    super();
    Object.defineProperties(this, Object.getOwnPropertyDescriptors(props));
  }
}

export default Page;
